<template lang="pug">
  b-row
    b-col(sm='12')
      b-form(@submit.prevent='submit')
        b-card
          div(slot='header')
            strong Modify inspection's informations
            small.pl-2 Form

          b-row
            b-col(sm='6')
              b-col(sm='12')
                b-form-fieldset(label='Inspection')
                  b-form-input(
                    type='text',
                    id='checklist_name'
                    name='name'
                    placeholder="Enter inspection's name"
                    v-model='checklist.name'
                    v-validate="'required'"
                  )
                  div.text-danger(v-show="errors.has('name')") {{ errors.first('name') }}
              b-col(sm='12')
                b-form-fieldset(label='Location')
                  b-form-input(
                    type='text'
                    id='checklist_location'
                    name='location'
                    placeholder='Enter location'
                    v-model='checklist.location'
                  )
              b-col(sm='12')
                b-form-fieldset(label='Date')
                  b-form-input(
                    type='date'
                    id='checklist_date'
                    name='date'
                    v-model='checklist.date'
                  )
            b-col(sm='6')
              b-col.pt-4(sm='12')
                b-alert(show variant='primary')
                  h5 Project
                  p {{ checklist.project.name }}
              b-col.pt-2(sm='12')
                b-alert(show variant='warning')
                  h5 Object
                  p {{ checklist.structure.card_name }}

          b-col.py-4(sm='12')
            button.btn.btn-primary.px-4(type='submit') Save

      template(v-for='(item, index) in checklist.checklist_items')
        c-checklist-item(
          :index='index'
          :checklistItem='item'
          @update-item-data='updateItemData'
          @remove-checklist-item='removeChecklistItem'
        )

      template
        b-col.py-4.text-center(sm='12')
          button.btn.btn-primary.px-4(type='button' @click='addChecklistItem')
            i.fa.fa-angle-double-down.fa-lg.px-2
            span Add inspection-item
            i.fa.fa-angle-double-down.fa-lg.px-2
</template>

<script>
  import server from '@/server'
  import Policeman from '@/utils/Policeman/policeman'
  import Messages from '@/utils/notificationsMsg'
  import Multiselect from 'vue-multiselect'
  import _ from 'lodash'
  import RouteGen from '@/utils/apiRoutes'
  import cChecklistItem from './subcomponents/EditItem'

  export default {
    name: 'ChecklistEdit',
    components: { Multiselect, cChecklistItem },
    data () {
      return {
        projectLoading: false,
        structuresLoading: false,
        checklist: {
          name: '',
          location: '',
          date: '',
          batch_code: '',
          project: {},
          structure: {
            card_name: ''
          },
          checklist_items: []
        }
      }
    },
    mounted () {
      this.fetchChecklist(this.$route.params.id)
    },
    methods: {
      updateItemData (item, index) {
        this.checklist.checklist_items[index] = item
      },
      fetchChecklist (checklistId) {
        let currentPermissions = this.$route.meta.roles
        if (!Policeman.authorize(currentPermissions)) {
          this.showNotification(401)
          this.$route.push({ name: 'Home' })
        }
        let route = RouteGen.show('checklist', checklistId)
        server.get(route)
          .then(res => {
            let checklist = res.data.checklist
            this.$set(this.$data, 'checklist', checklist)
          })
          .catch(err => {
            console.log(err)
          })
      },
      asyncFindProjects: _.debounce(
        function (query) {
          this.projectLoading = true
          let url = RouteGen.index('project')
          server.get(url, {
            params: {
              'q[name_cont]': query
            }
          })
          .then(res => {
            this.$set(this.$data, 'projectsList', res.data.projects)
            this.projectLoading = false
          })
          .catch(err => {
            console.log(err)
            this.projectLoading = false
          })
        },
        700
      ),
      addChecklistItem () {
        this.checklist.checklist_items.push({
          name: '',
          component_name: ''
        })
      },
      removeChecklistItem (index) {
        this.checklist.checklist_items.splice(index, 1)
        this.$set(this.$data.checklist, 'checklist_items', this.$data.checklist.checklist_items)
      },
      submit () {
        this.$validator
          .validateAll()
          .then((result) => {
            if (result) {
              this.saveChecklist(this.$route.params.id)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      saveChecklist (id = null) {
        let url = RouteGen.edit('checklist', id)
        let messageModifier = 'updated'
        delete this.$data.checklist.batch_code // if PATCH, batch_code is removed

        server.patch(url, { checklist: this.$data.checklist })
          .then(res => {
            this.showNotification(201, messageModifier)
            this.$router.push({ name: 'All inspections' })
          })
          .catch(err => {
            this.showNotification(err.response.status)
          })
      },
      showNotification (status, modifier) {
        return this.getMessage(Messages.byStatus(status, 'Inspection', modifier))
      }
    },
    notifications: {
      getMessage: {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Checklist/Edit.vue